/**
 * Display individual config key/value
 * 
 * @author: Vanessa Richie Alia-Trapero <vanessa@dividia.net>
 */

import { useState } from 'react'
import MotionGrid from "./MotionGrid"

const ConfigField = ({deviceId, group, name, value, handleInputChange}) => {
  const bCamera = group.startsWith('camera') ? parseInt(group.slice('6')) : 0
  const [gridValue, setGridValue] = useState(value)

  // update the hidden text field linked to the motion grid
  const handleGridChange = (val) => {
    setGridValue(val)
    // simulate e.target structure then propagate to ConfigForm
    const e = {target: {
      dataset: {group: group},
      value: val,
      name: name,
    }}
    handleInputChange(e)
  }

  const renderField = (name) => {  
    let field = <input type="text" name={name} defaultValue={value} data-group={group} onChange={handleInputChange} style={styles.formInputText} />
      
    // if the number of different field type increases, we could create a variable for it that holds the field and type mapping
    // for now this will be fixed based on the types that we currently know
    
    if ((group === 'global' && ['localtime', 'use_b2'].includes(name)) || (group.startsWith('camera') && name === 'enabled')) {
      // eslint-disable-next-line
      return <input type="checkbox" checked={value == 1 ? true : false} name={name} defaultValue={value} data-group={group} onChange={handleInputChange} style={styles.formInputCheckbox} />
    } else if (group.startsWith('camera')) {
      if (name === 'still_interval') {
        return <input type="number" min="0" name={name} defaultValue={value} data-group={group} onChange={handleInputChange} style={styles.formInputText} />
      } else if (name === 'motion_sens') {
        return <input type="number" min="0" step="0.01" name={name} defaultValue={value} data-group={group} onChange={handleInputChange} style={styles.formInputText} />
      } else if (name === 'motion_grid_mask') {
        return <><input type="hidden" name={name} defaultValue={gridValue} /><MotionGrid deviceId={deviceId} bCamera={bCamera} value={gridValue} onChange={handleGridChange} /></>
      }
    }

    return field
  }

  return (
    <div style={(name === 'motion_grid_mask' ? {...styles.formInputMaskRow} : {...styles.formInputRow})}>
      <label style={styles.formInputLabel}>{name}</label>
      {renderField(name)}
    </div>
  )
}
export default ConfigField

const styles = {
  formInputRow: {
    display: 'flex', 
    alignItems: 'center', 
    paddingBottom: '1vmin',
  },
  formInputMaskRow: {
    display: 'flex', 
    alignItems: 'center', 
    paddingBottom: '1vmin',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  formInputLabel: {
    margin: 0, 
    fontSize: '1.6vmin', 
    width: '49%',
  },
  formInputCheckbox: {
    fontSize: '1.6vmin', 
  },
  formInputText: {
    fontSize: '1.6vmin', 
    width: '50%', 
  },
}